/*Redux connect*/
import { connect } from "react-redux";
import { getAccountManagerList, SubmitRequst } from "../../../../redux/actions/userManagement/submitOnbardingRequest";
import NewCustomer from "./NewCustomer";
import { openAlertPopup } from "../../../../redux/actions/Alert/alert.action";
import { setActivePrimaryTab } from "../../../../redux/actions/userManagement/userManagementTab.action";
import { redirectTab } from "../../../../redux/actions/userManagement/redirectTab.action";
import { getFincaTadig } from "../../../../redux/actions/finca/fincaTadig.action";
import { getCustomerEmail } from "../../../../redux/actions/userManagement/getCustomerEmail.action";
import { getEmailToVerify } from "../../../../redux/actions/userManagement/getEmailToVerify.action";


const mapStateToProps = (state) => {

    return {
    submitting: state.submitCustomerDetails.loading,
    list:state.onboardingRequest.getAllCustomerList.data,
    // list: state.customerList.list,
    accountManagerList: state.onboardingRequest.accountMManagerList.data,
    myRights:state.myRights.myRights,
    fincaTadig : state.fincaTadig,
    activePrimaryTab :state.tabReducer.activePrimaryTab,
    isExistingEmail:state.onboardingRequest.getCustomerEmail.data,
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
      submitRequest: (payload) => {
        return dispatch(SubmitRequst(payload))
      }, 
      openAlertPopup: (payload) => {
        return dispatch(openAlertPopup(payload))
      }, 
      getAccountManagerList: (payload)=>{
        return dispatch(getAccountManagerList(payload))
    },
    setActivePrimaryTab: (tab) => {
      return dispatch(setActivePrimaryTab(tab))
    },
    redirectTab: (tab) => {
      return dispatch(redirectTab(tab))
    },
    //   getOnboardingList: (next=null)=>{
    //     return dispatch(getOnboardingList(next))
    // },
    getFincaTadig: () => {
      return dispatch(getFincaTadig())
    },  
    getCustomerEmail: (email="") => {
      return dispatch(getCustomerEmail(email))
    }, 
    getEmailToVerify: (email) => {
      return dispatch(getEmailToVerify(email))
    }, 
    }
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(NewCustomer);


